import axios from '@/lib/axios'
export function search(data = {}) {
  return axios().post('/api/search/person_search', data)
}
